import { Component, Input } from '@angular/core';
import {
  computeWarrantyState,
  WARRANTY_STATES,
  WarrantyState,
  Warranty,
} from './warranty-state.util';

@Component({
  selector: 'app-warranty-state-diagram',
  templateUrl: './warranty-state-diagram.component.html',
  styleUrls: ['./warranty-state-diagram.component.scss'],
  standalone: false,
})
export class WarrantyStateDiagramComponent {
  @Input() warranty: Warranty | null = null;
  /** Compact bar variant for table cells — renders just the tick row. */
  @Input() compact = false;

  readonly states: WarrantyState[] = WARRANTY_STATES;

  get currentKey(): string | null {
    return computeWarrantyState(this.warranty)?.key || null;
  }

  get currentIndex(): number {
    const k = this.currentKey;
    if (!k) return -1;
    return this.states.findIndex(s => s.key === k);
  }

  isPast(i: number): boolean {
    return this.currentIndex > i;
  }

  isCurrent(i: number): boolean {
    return this.currentIndex === i;
  }
}
